howspace.commentsTrait.moveComment = (() => {
    'use strict';

    let draggingComment = null; // Comment being dragged.
    let draggingCommentPlaceholder = null; // An invisible placeholder where the comment was originally located.
    let dragClone = null; // Clone of the comment being dragged.
    let startX = null; // X position of the pointer when starting the drag.
    let startY = null; // Y position of the pointer when starting the drag.
    let verticalScrollContainer = null; // Vertical scroll container for the auto scroll.
    let horizontalScrollContainer = null; // Horizontal scroll container for the auto scroll.
    let verticalScrollThreshold = null; // Distance from the edge to start vertical auto scroll.
    let horizontalScrollThreshold = null; // Distance from the edge to start horizontal auto scroll.
    let verticalScrollSpeed = 0; // Speed of the vertical auto scroll.
    let horizontalScrollSpeed = 0; // Speed of the horizontal auto scroll.
    let verticalScrollIntervalId = null; // Interval id for the vertical auto scroll.
    let horizontalScrollIntervalId = null; // Interval id for the horizontal auto scroll.
    let latestY = null; // Latest Y position of the pointer.
    let latestX = null; // Latest X position of the pointer.
    let goingUp = false; // Is the pointer going up.
    let goingDown = false; // Is the pointer going down.
    let goingLeft = false; // Is the pointer going left.
    let goingRight = false; // Is the pointer going right.

    const init = (widget) => {
        widget.on('keydown', '.move-comment-btn', handleMoveCommentKeyDown);
        widget.on('pointerdown', '.move-comment-btn', handleMoveCommentPointerDown);
        widget[0].addEventListener('touchmove', handleTouchMove, {passive: false});
    };

    const destroy = (widget) => {
        widget.off('keydown', '.move-comment-btn', handleMoveCommentKeyDown);
        widget.off('pointerdown', '.move-comment-btn', handleMoveCommentPointerDown);
        widget[0].removeEventListener('touchmove', handleTouchMove, {passive: false});
    };

    const handleTouchMove = e => {
        // Prevent scrolling while dragging a comment on touch devices.
        if (draggingComment !== null) {
            e.preventDefault();
        }
    };

    const handleMoveCommentKeyDown = e => {
        const comment = e.currentTarget.closest('.comment');
        if (e.key === 'Enter' && draggingComment === null) {
            startKeyboardDrag(comment);
        }
    };

    const handleMoveCommentPointerDown = e => {
        if (draggingComment !== null) {
            // Already dragging a comment.
            return;
        }

        if (e.originalEvent.pointerType === 'mouse' && e.originalEvent.button !== 0) {
            // Do not start dragging if the pointer is mouse and user didn't click with left button.
            return;
        }

        // Set pointer capture (the target captures all pointer events).
        e.target.setPointerCapture(e.pointerId);

        const btn = e.target;
        draggingComment = btn.closest('.comment');

        const rect = draggingComment.getBoundingClientRect();
        dragClone = $('<div/>');
        dragClone.addClass('comment-clone');
        dragClone.text(draggingComment.querySelector('.comment-text').innerText.trim());
        real.dom.$body.append(dragClone);
        const height = dragClone.outerHeight();
        const style = getComputedStyle(draggingComment.querySelector('.comment-content'));
        dragClone.css({
            width: rect.width + 'px',
            height: rect.height + 'px',
            left: rect.x + 'px',
            top: rect.y + 'px',
            backgroundColor: style.getPropertyValue('background-color'),
            color: style.getPropertyValue('color'),
            borderRadius: 'var(--howspace-border-radius-2)',
            opacity: 0,
        });

        howspace.animate(dragClone, {opacity: 1, height: height + 'px'}, 300);

        real.dom.$body.on('pointermove', drag);
        real.dom.$body.on('pointerup', stopDrag);

        startY = e.clientY;
        startX = e.clientX;
        startDrag();
    };

    const startKeyboardDrag = (comment) => {
        draggingComment = comment;
        startDrag();
    };

    const updateVerticalScrollContainer = () => {
        verticalScrollContainer = draggingComment.closest('.comment-category').querySelector('.category-content');
    }

    const startDrag = () => {
        updateVerticalScrollContainer();
        horizontalScrollContainer = draggingComment.closest('.comments-categories');

        // Set the thresholds for auto scrolling. Limit to max 200px or 1/3 of the viewport size.
        verticalScrollThreshold = Math.min(200, Math.round(window.innerHeight / 3));
        horizontalScrollThreshold = Math.min(200, Math.round(window.innerWidth / 3));

        draggingCommentPlaceholder = $(`<div class="dragging-comment-placeholder"></div>`)[0];
        draggingCommentPlaceholder.dataset.categoryId = draggingComment.closest('.comment-category')?.dataset.categoryId || '';
        draggingCommentPlaceholder.dataset.order = draggingComment.dataset.order || '1';
        draggingComment.after(draggingCommentPlaceholder);

        draggingComment.classList.add('dragging');
        howspace.components.toolTip.disable(draggingComment.querySelector('.move-comment-btn'));

        if (!real.dom.$body.hasClass('dragging')) {
            real.dom.$body.addClass('dragging');
            setTimeout(() => {
                real.dom.$body.on('keydown', handleBodyKeyDown);
            });
        }
    };

    const getPreviousComment = comment => {
        let prev = comment.previousElementSibling;
        while (prev !== null) {
            if (prev.classList.contains('comment')) {
                return prev;
            }
            prev = prev.previousElementSibling;
        }
        return null;
    }

    const getNextComment = comment => {
        let next = comment.nextElementSibling;
        while (next !== null) {
            if (next.classList.contains('comment')) {
                return next;
            }
            next = next.nextElementSibling;
        }
        return null;
    }

    const verticalAutoScroll = () => {
        if (!verticalScrollContainer) {
            return;
        }
        verticalScrollContainer.scrollBy({
            top: verticalScrollSpeed,
            behavior: 'instant'
        });
    };

    const horizontalAutoScroll = () => {
        if (!horizontalScrollContainer) {
            return;
        }
        horizontalScrollContainer.scrollBy({
            left: horizontalScrollSpeed,
            behavior: 'instant'
        });
    }

    const drag = e => {
        dragClone.css({
            transform: `translate(${e.clientX - startX}px, ${e.clientY - startY}px)`
        });

        const elemAtPoint = document.elementFromPoint(e.clientX, e.clientY);

        if (!goingUp && e.clientY < latestY) {
            goingUp = true;
            goingDown = false;
            if (verticalScrollSpeed > 0) {
                verticalScrollSpeed = 0;
            }
        }

        if (!goingDown && e.clientY > latestY) {
            goingDown = true;
            goingUp = false;
            if (verticalScrollSpeed < 0) {
                verticalScrollSpeed = 0;
            }
        }

        if (!goingLeft && e.clientX < latestX) {
            goingLeft = true;
            goingRight = false;
            if (horizontalScrollSpeed > 0) {
                horizontalScrollSpeed = 0;
            }
        }

        if (!goingRight && e.clientX > latestX) {
            goingRight = true;
            goingLeft = false;
            if (horizontalScrollSpeed < 0) {
                horizontalScrollSpeed = 0;
            }
        }

        latestY = e.clientY;
        latestX = e.clientX;

        if (goingUp) {
            const rect = verticalScrollContainer.getBoundingClientRect();
            const pixelsFromTop = Math.max(0, e.clientY - rect.top);
            verticalScrollSpeed = Math.max(0, verticalScrollThreshold - pixelsFromTop) / 10 * -1;
        } else if (goingDown) {
            const rect = verticalScrollContainer.getBoundingClientRect();
            const pixelsFromBottom = rect.bottom - e.clientY;
            verticalScrollSpeed = Math.max(0, verticalScrollThreshold - pixelsFromBottom) / 10;
        }

        if (goingLeft) {
            const rect = horizontalScrollContainer.getBoundingClientRect();
            const pixelsFromLeft = Math.max(0, e.clientX - rect.left);
            horizontalScrollSpeed = Math.max(0, horizontalScrollThreshold - pixelsFromLeft) / 10 * -1;
        } else if (goingRight) {
            const rect = horizontalScrollContainer.getBoundingClientRect();
            const pixelsFromRight = rect.right - e.clientX;
            horizontalScrollSpeed = Math.max(0, horizontalScrollThreshold - pixelsFromRight) / 10;
        }

        if (verticalScrollIntervalId !== null && verticalScrollSpeed === 0) {
            clearInterval(verticalScrollIntervalId);
            verticalScrollIntervalId = null;
        } else if (verticalScrollIntervalId === null && verticalScrollSpeed !== 0) {
            verticalScrollIntervalId = setInterval(verticalAutoScroll, 10);
        }

        if (horizontalScrollIntervalId !== null && horizontalScrollSpeed === 0) {
            clearInterval(horizontalScrollIntervalId);
            horizontalScrollIntervalId = null;
        } else if (horizontalScrollIntervalId === null && horizontalScrollSpeed !== 0) {
            horizontalScrollIntervalId = setInterval(horizontalAutoScroll, 10);
        }

        if (elemAtPoint?.closest('.widget') === null || elemAtPoint?.closest('.widget')?.dataset?.widgetId !== draggingComment.closest('.widget')?.dataset?.widgetId) {
            // Not over the same widget, restore original position.
            if (draggingCommentPlaceholder !== null) {
                const oldRect = draggingComment.getBoundingClientRect();
                draggingCommentPlaceholder.before(draggingComment);
                animateCommentMove(draggingComment, oldRect);
                updateVerticalScrollContainer();
            }
            return;
        }

        if (elemAtPoint.classList.contains('comment') && elemAtPoint !== draggingComment) {
            const rect = elemAtPoint.getBoundingClientRect();
            const midpoint = rect.y + rect.height / 2;
            if (e.clientY < midpoint && getPreviousComment(elemAtPoint) !== draggingComment) {
                const oldRect = draggingComment.getBoundingClientRect();
                elemAtPoint.before(draggingComment);
                animateCommentMove(draggingComment, oldRect);
                updateVerticalScrollContainer();
                return;
            } else if (e.clientY >= midpoint && getNextComment(elemAtPoint) !== draggingComment) {
                const oldRect = draggingComment.getBoundingClientRect();
                elemAtPoint.after(draggingComment);
                animateCommentMove(draggingComment, oldRect);
                updateVerticalScrollContainer();
                return;
            }
        }

        if (elemAtPoint.classList.contains('category-content') && !elemAtPoint.querySelector('.comment.dragging')) {
            const oldRect = draggingComment.getBoundingClientRect();
            const cards = elemAtPoint.querySelector('.howspace-lister-cards');
            elemAtPoint.querySelector('.howspace-lister-no-items').style.display = 'none';
            cards.style.display = 'block';
            cards.append(draggingComment);
            animateCommentMove(draggingComment, oldRect);
            updateVerticalScrollContainer();
        }
    };

    // FLIP animation: draggingComment (the reduced-opacity card marking its own new slot while
    // the separate dragClone follows the pointer) already reparented above, snapping to its new
    // position instantly. Offset it back to where it visually was with a transition-less
    // transform, then release that transform with a transition on the next frame so it glides
    // to its new slot instead of just appearing there.
    const animateCommentMove = (elem, oldRect) => {
        if (!howspace.animate.isEnabled()) {
            return;
        }

        const newRect = elem.getBoundingClientRect();
        const dx = oldRect.left - newRect.left;
        const dy = oldRect.top - newRect.top;

        if (dx === 0 && dy === 0) {
            return;
        }

        elem.classList.remove('comment-move-transition');
        elem.style.transform = `translate(${dx}px, ${dy}px)`;

        // Force layout so the offset above is applied before the transition class kicks in below.
        elem.getBoundingClientRect();

        requestAnimationFrame(() => {
            elem.classList.add('comment-move-transition');
            elem.style.transform = '';
            elem.addEventListener('transitionend', function onTransitionEnd(e) {
                if (e.target !== elem || e.propertyName !== 'transform') {
                    // Ignore bubbled transitionend events from descendants.
                    return;
                }
                elem.classList.remove('comment-move-transition');
                elem.removeEventListener('transitionend', onTransitionEnd);
            });
        });
    };

    const cancelDrag = () => {
        if (draggingComment === null) {
            return;
        }
        if (draggingCommentPlaceholder !== null) {
            draggingCommentPlaceholder.before(draggingComment);
            draggingCommentPlaceholder.remove();
            draggingCommentPlaceholder = null;
        }
        stopDrag();
    };

    const stopDrag = () => {
        howspace.components.toolTip.enable(draggingComment.querySelector('.move-comment-btn'));

        real.dom.$body.removeClass('dragging');
        document.querySelector('.comment.dragging')?.classList.remove('dragging');

        real.dom.$body.off('keydown', handleBodyKeyDown);
        real.dom.$body.off('pointermove', drag);
        real.dom.$body.off('pointerup', stopDrag);

        if (draggingCommentPlaceholder !== null) {
            const previousComment = getPreviousComment(draggingComment);
            const newCategoryId = draggingComment.closest('.comment-category')?.dataset.categoryId || null;
            const newOrder = parseInt(previousComment?.dataset?.order || '0') + 1;
            const originalCategoryId = draggingCommentPlaceholder.dataset.categoryId || null;
            const originalOrder = parseInt(draggingCommentPlaceholder.dataset.order || '1');

            if (newCategoryId !== originalCategoryId || newOrder !== originalOrder) {
                const widget = draggingComment.closest('.widget');
                const url = howspace.widgets.getApiUrl(widget) + '/comment/' + draggingComment.dataset.id;
                const dataPayload = {
                    _action: 'categorize',
                    category_id: newCategoryId,
                    order: newOrder,
                };
                real.ajax.json(url, {
                    type: 'POST',
                    data: JSON.stringify(dataPayload)
                });

                if (newCategoryId !== originalCategoryId) {
                    const $widget = $(widget);
                    const originalCategory = howspace.commentsTrait.getCategory($widget, originalCategoryId);
                    const newCategory = howspace.commentsTrait.getCategory($widget, newCategoryId);
                    howspace.components.lister.updateItemsCount(originalCategory.find('.howspace-lister.comments'), -1);
                    howspace.components.lister.updateItemsCount(newCategory.find('.howspace-lister.comments'), 1);
                }
            }

            draggingCommentPlaceholder.remove();
            draggingCommentPlaceholder = null;

        }

        if (dragClone !== null) {
            dragClone.remove();
            dragClone = null;
        }

        verticalScrollSpeed = 0;
        if (verticalScrollIntervalId !== null) {
            clearInterval(verticalScrollIntervalId);
            verticalScrollIntervalId = null;
        }

        horizontalScrollSpeed = 0;
        if (horizontalScrollIntervalId !== null) {
            clearInterval(horizontalScrollIntervalId);
            horizontalScrollIntervalId = null;
        }

        howspace.commentsTrait.checkUncategorizedComments($(draggingComment.closest('.widget')));
        draggingComment = null;
        verticalScrollContainer = null;
    };

    const keyboardMoveCommentLeft = (e) => {
        e.preventDefault();
        const currentCategory = draggingComment.closest('.comment-category');
        const previousCategory = currentCategory.previousElementSibling;
        if (previousCategory && previousCategory.classList.contains('comment-category')) {
            // Move to previous category.
            previousCategory.querySelector('.howspace-lister-cards').prepend(draggingComment);
            if (previousCategory.classList.contains('collapsed')) {
                // Expand the collapsed category.
                previousCategory.classList.remove('collapsed');
            }
            updateVerticalScrollContainer();
        }
    };

    const keyboardMoveCommentRight = (e) => {
        e.preventDefault();
        const currentCategory = draggingComment.closest('.comment-category');
        const nextCategory = currentCategory.nextElementSibling;
        if (nextCategory && nextCategory.classList.contains('comment-category')) {
            // Move to next category.
            nextCategory.querySelector('.howspace-lister-cards').prepend(draggingComment);
            updateVerticalScrollContainer();
        }
    };

    const keyboardMoveCommentUp = (e) => {
        e.preventDefault();
        const previousComment = getPreviousComment(draggingComment);
        if (previousComment) {
            // Move up within the same category.
            previousComment.before(draggingComment);
        }
    };

    const keyboardMoveCommentDown = (e) => {
        e.preventDefault();
        const nextComment = getNextComment(draggingComment);
        if (nextComment) {
            // Move down within the same category.
            nextComment.after(draggingComment);
        }
    };

    const keyDownActions = {
        Enter: stopDrag,
        Escape: cancelDrag,
        ArrowUp: keyboardMoveCommentUp,
        ArrowDown: keyboardMoveCommentDown,
        ArrowLeft: keyboardMoveCommentLeft,
        ArrowRight: keyboardMoveCommentRight,
    };

    const handleBodyKeyDown = e => {
        if (draggingComment !== null && keyDownActions[e.key]) {
            keyDownActions[e.key](e);
        }
    };

    return {
        init: init,
        destroy: destroy,
        isDraggingComment: comment => {
            return howspace.getDOMElement(comment) === draggingComment;
        },
        cancelDrag: cancelDrag,
    };
})();
